import { Box, Button } from '@mui/material';

import { PLAN_COLORS } from '../constants';
import type { DailyPlan } from '../types';
import { exportDailyViewCsv } from '../utils/dailyViewExport';

const HORIZON_OPTIONS = [30, 60, 90, 120, 180, 365];

const DV = {
  navy: '#0f1623',
  text2: '#4a5568',
  text3: '#718096',
  border: '#e2e8f0',
  border2: '#cbd5e0',
} as const;

interface DailyViewHorizonBarProps {
  horizon: number;
  onHorizonChange: (horizon: number) => void;
  dailyPlan: DailyPlan;
}

/** Daily View horizon filters — rendered inside the sticky plan header below tabs. */
export const DailyViewHorizonBar = ({
  horizon,
  onHorizonChange,
  dailyPlan,
}: DailyViewHorizonBarProps) => (
  <Box
    sx={{
      display: 'flex',
      gap: 1,
      alignItems: 'center',
      flexWrap: 'wrap',
      py: 0.75,
      px: 0,
      bgcolor: 'background.paper',
      borderBottom: '1px solid',
      borderColor: DV.border,
    }}
  >
    <Box sx={{ fontSize: 12, color: DV.text2, fontWeight: 500 }}>Show first</Box>
    {HORIZON_OPTIONS.map((n) => (
      <Button
        key={n}
        onClick={() => onHorizonChange(n)}
        sx={{
          minWidth: 0,
          px: 1.5,
          py: 0.625,
          fontSize: 11,
          lineHeight: 1.2,
          borderRadius: 20,
          border: `1px solid ${horizon === n ? PLAN_COLORS.orange : DV.border2}`,
          bgcolor: horizon === n ? PLAN_COLORS.orange : 'transparent',
          color: horizon === n ? '#fff' : DV.text3,
          fontFamily: 'Plus Jakarta Sans, sans-serif',
          fontWeight: 400,
          textTransform: 'none',
          boxShadow: 'none',
          '&:hover': {
            bgcolor: horizon === n ? PLAN_COLORS.orange : 'transparent',
            boxShadow: 'none',
          },
        }}
      >
        {n}d
      </Button>
    ))}
    <Button
      onClick={() => exportDailyViewCsv(dailyPlan, horizon)}
      sx={{
        ml: 'auto',
        px: 1.75,
        py: 0.625,
        fontSize: 11,
        fontWeight: 600,
        borderRadius: 20,
        bgcolor: DV.navy,
        color: '#fff',
        fontFamily: 'Plus Jakarta Sans, sans-serif',
        textTransform: 'none',
        boxShadow: 'none',
        '&:hover': { bgcolor: DV.navy, opacity: 0.9 },
      }}
    >
      ↓ Export CSV
    </Button>
  </Box>
);
